import { render } from "./side-menu-element.vue?vue&type=template&id=3b2eeb53&scoped=true"
import script from "./side-menu-element.vue?vue&type=script&lang=js"
export * from "./side-menu-element.vue?vue&type=script&lang=js"

import "./side-menu-element.vue?vue&type=style&index=0&id=3b2eeb53&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2eeb53"]])

export default __exports__